<template>
  <div class="login-container" :class="{ 'weflix': typeSystem == 2, 'weeduc': typeSystem == 1 }">
    <div class="form-column">
      <div class="form-content">
        <div class="logo">
          <img alt="Vue logo" src="@/assets/logo.png" v-show="typeSystem==1" />
          <img alt="Weflix" src="@/assets/Weflix/logo_weflix.png" v-show="typeSystem==2" />
        </div>

        <div class="form-wrapper">
          <h3>Crie sua senha</h3>

          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label for="password">Digite sua senha</label>
              <div class="password-input">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  v-model="password"
                  id="password"
                  class="form-control"
                  placeholder="Digite sua senha"
                  :disabled="showSuccessPopup"
                />
                <i class="fas" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'" @click="togglePassword"></i>
              </div>
            </div>

            <div class="form-group">
              <label for="confirmPassword">Confirme sua senha</label>
              <div class="password-input">
                <input
                  :type="showConfirmPassword ? 'text' : 'password'"
                  v-model="confirmPassword"
                  id="confirmPassword"
                  class="form-control"
                  placeholder="Confirme sua senha"
                  :disabled="showSuccessPopup"
                />
                <i class="fas" :class="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'" @click="toggleConfirmPassword"></i>
              </div>
            </div>

            <p class="error-message" v-if="errorMessage">{{ errorMessage }}</p>
            <!-- Success message removed as it's handled by the popup -->
            <!-- <p class="success-message" v-if="successMessage">{{ successMessage }}</p> -->

            <div class="button-wrapper">
              <button type="submit" class="btn-submit" :class="{'weflix': typeSystem==2, 'weeduc': typeSystem==1}" :disabled="showSuccessPopup">
              Salvar e Ativar Conta
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="image-column"></div>

    <!-- Success Popup -->
    <div v-if="showSuccessPopup" class="popup-overlay">
      <div class="popup-content">
        <h4>Sucesso!</h4>
        <p>Sua conta foi ativada com sucesso.</p>
        <button @click="handleContinue" class="btn-popup-continue" :class="{'weflix': typeSystem==2, 'weeduc': typeSystem==1}">
          Continuar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import apiPassword from '@/utils/password.js';
import loginApi from '@/utils/login.js';
import ApiPayment from '@/utils/Weflix/Website/payment.js';

export default {
  data() {
    return {
      password: '',
      confirmPassword: '',
      showPassword: false,
      showConfirmPassword: false,
      errorMessage: '',
      // successMessage: '', // Removed, using popup instead
      showSuccessPopup: false, // Controls popup visibility
      typeSystemLocal: 1,
      baseUrl: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_BASE_URL_HOMOLOGATION : window.location.origin,
    };
  },
  computed: {
    ...mapState(['typeSystem'])
  },
  methods: {
    ...mapActions(['storeTypeSystem']),

    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },

    async getLogo() {
      const aux = this.baseUrl.replace(/\/$/, '');
      const url = aux.split('/setpassword')[0];
      const obj = { url: url };

      try {
        const response = await loginApi.logo(obj);
        // Assuming logo setting was intended but missing 'this.logo ='
        // this.logo = 'https://image.weeduc.com/' + response.logo;
        this.storeTypeSystem({ typeSystem: response.typeSystem });
        this.typeSystemLocal = response.typeSystem;
      } catch (error) {
        console.error('Error fetching API:', error);
        // Handle error appropriately, maybe show a message to the user
      }
    },

    async handleSubmit() {
      this.errorMessage = ''; // Clear previous errors
      if (this.password !== this.confirmPassword) {
        this.errorMessage = 'As senhas não coincidem';
        return;
      }

      if (this.password.length < 6) {
        this.errorMessage = 'A senha deve ter pelo menos 6 caracteres';
        return;
      }
      const payload = {
        password: this.password,
        token: this.$route.params.slug
      }

      console.log(payload);
      try {
        const response = await ApiPayment.activeAccount(payload);
        // Check response status if necessary, assuming success if no error is thrown
        console.log('Account activation response:', response);
        this.showSuccessPopup = true; // Show the success popup
      } catch (error) {
        console.error('Erro ao ativar conta:', error);
        // Display a more user-friendly error message
        this.errorMessage = 'Erro ao ativar a conta. Verifique o link ou tente novamente mais tarde.';
        if (error.response && error.response.data && error.response.data.message) {
            this.errorMessage = error.response.data.message; // Use backend error message if available
        }
      }
    },

    handleContinue() {
      this.showSuccessPopup = false;
      this.$router.push('/');
    }
  },
  mounted() {
    this.getLogo();
    // No need to set typeSystemLocal from typeSystem here, getLogo handles it.
    // If getLogo fails, typeSystemLocal will remain 1, which might be desired fallback.
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  height: 100vh;
  position: relative; /* Needed for popup overlay positioning */
}

.form-column {
  width: 30%;
  background: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  z-index: 1; /* Ensure form is above potential background elements */
}

.image-column {
  width: 70%;
  background-image: url("../assets/Weflix/fundo-set-senha.png");
  background-size: cover;
  background-position: center;
}

.form-content {
  width: 100%;
  max-width: 400px;
}

.logo {
  text-align: center;
  margin-bottom: 2rem;
}

.logo img {
  max-width: 180px;
  height: auto;
}

.form-wrapper {
  background: #000000;
  padding: 2rem;
  border-radius: 8px;
  /* Removed box-shadow as background is black */
}

h2 { /* Assuming h3 was meant to be styled like h2 */
  text-align: center;
  margin-bottom: 2rem;
  color: #ffffff; /* Changed color for black background */
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #ffffff;
  font-size: 0.9rem;
  font-weight: 700;
}

.password-input {
  position: relative;
}

.password-input input {
  width: 100%;
  padding: 0.8rem;
  /* border: 1px solid #ddd; */ /* Border color handled below */
  border-radius: 4px;
  font-size: 1rem;
}

.password-input i {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #ccc; /* Adjusted color for dark input */
}

.error-message {
  color: #dc3545;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  text-align: center; /* Center error message */
}

/* Removed success-message style as it's replaced by popup */

.button-wrapper {
  text-align: center;
  margin-top: 2rem;
}

.btn-submit {
  padding: 0.8rem 2rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  font-weight: bold;
}
.btn-submit:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn-submit.weflix {
  background-color: #1d4daf;
  color: white;
}

.btn-submit.weeduc {
  background-color: #28a745;
  color: white;
}

.btn-submit:hover:not(:disabled) {
  opacity: 0.9;
}

/* Popup Styles */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7); /* Dark overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000; /* Ensure popup is on top */
}

.popup-content {
  background-color: #2c2c2c; /* Dark background for popup */
  color: #ffffff; /* White text */
  padding: 2rem 3rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 90%;
}

.popup-content h4 {
    margin-top: 0;
    margin-bottom: 1rem;
    color: #ffffff;
    font-size: 1.5rem;
    font-weight: 600;
}

.popup-content p {
  margin-bottom: 1.5rem;
  font-size: 1rem;
}

.btn-popup-continue {
  padding: 0.7rem 1.5rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: bold;
}

.btn-popup-continue.weflix {
  background-color: #1d4daf;
  color: white;
}

.btn-popup-continue.weeduc {
  background-color: #28a745;
  color: white;
}

.btn-popup-continue:hover {
  opacity: 0.9;
}


@media (max-width: 768px) {
  .login-container {
    /* Apply background image to the container itself on mobile */
    background-image: url("../assets/Weflix/fundo-set-senha.png");
    background-size: cover;
    background-position: center;
    /* Remove flex direction, form column will handle layout */
    /* flex-direction: column; */
  }

  .form-column {
    width: 100%;
    height: 100vh; /* Take full viewport height */
    /* Create the overlay effect */
    background-color: rgba(0, 0, 0, 0.7);
    /* Ensure content is centered within the overlay */
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem; /* Adjust padding as needed */
    order: initial; /* Reset order */
    min-height: auto; /* Reset min-height */
    z-index: 2; /* Ensure form overlay is above background */
  }

  .image-column {
    /* Hide the dedicated image column on mobile */
    display: none;
  }

  .form-content {
     max-width: 90%; /* Limit form width slightly */
     width: 100%; /* Ensure it uses available space */
  }

  .form-wrapper {
    /* Make form wrapper transparent, overlay is on form-column */
    background: transparent;
    padding: 0; /* Remove padding, handled by form-column */
    border-radius: 0; /* Remove radius if not needed */
  }

  .popup-content {
    padding: 1.5rem;
  }
}

input#password, input#confirmPassword {
    background-color: #3c3c3c;
    border: 1px solid #555; /* Slightly lighter border for visibility */
    color: white;
}
input#password:focus, input#confirmPassword:focus {
    outline: none;
    border-color: #1d4daf; /* Highlight focus */
    box-shadow: 0 0 0 2px rgba(29, 77, 175, 0.5); /* Focus ring */
}


.form-wrapper > h3 {
    color: white;
    /* margin: 29px; */ /* Replaced by padding on form-wrapper */
    margin-bottom: 2rem; /* Added margin bottom */
    text-align: center; /* Center title */
    font-weight: 700;
    font-size: 1.8rem; /* Increase title size */
}
input#password::placeholder,
input#confirmPassword::placeholder {
  color: #a0a0a0; /* Lighter placeholder text */
  opacity: 1; /* Opacity handled by color */
}

/* Placeholder styles for different browsers */
input#password::-webkit-input-placeholder,
input#confirmPassword::-webkit-input-placeholder {
  color: #a0a0a0;
  opacity: 1;
}

input#password::-moz-placeholder,
input#confirmPassword::-moz-placeholder {
  color: #a0a0a0;
  opacity: 1;
}

input#password:-ms-input-placeholder,
input#confirmPassword:-ms-input-placeholder {
  color: #a0a0a0;
  opacity: 1;
}

input#password::-ms-input-placeholder,
input#confirmPassword::-ms-input-placeholder {
  color: #a0a0a0;
  opacity: 1;
}

</style>
